import React, { useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { useFetchAllCompany } from "../../../../../hooks/guide/useFetchAllCompany";
import { Company } from "../../../../../types/api/guide/company.types";
import { companyService } from "../../../../../services/guide/company-service";
import { CompanyAddModal } from "../../ui/EntityModal/CompanyAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface OrganizationsTableProps {
    title: string;
}

export const OrganizationsTable = ({ title }: OrganizationsTableProps) => {
    const { data: companies, refetch } = useFetchAllCompany();
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();
    const [toDelete, setToDelete] = useState<Company | null>(null);

    const [openModal, setOpenModal] = useState<{
        isOpen: boolean;
        company?: Company;
    }>({ isOpen: false });

    const handleDelete = async (id: string) => {
        try {
            await companyService.delete(id);
            showSuccess("Успешное удаление")
            refetch();
        } catch (e) {
            showError(e.response.data);
            console.log("Ошибка при удалении организации");
        }
    };

    return (
        <>
            <SimpleTable<Company>
                title={title}
                columns={[{ key: "name", title: "Название" }]}
                data={companies}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenModal({ isOpen: true, company: row }), // ✅ передаём row

                    onDelete: () => setToDelete(row),
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenModal({ isOpen: true, company: undefined })} // ✅ create
            />

            <ConfirmDialog
                open={!!toDelete}
                title="Удалить организацию?"
                description={toDelete ? `Будет удалена: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {openModal.isOpen && (
                <CompanyAddModal
                    company={openModal.company}
                    onClose={() => setOpenModal({ isOpen: false, company: undefined })}
                    refetchData={refetch}
                />
            )}
            <SnackbarComponent/>
        </>
    );
};
